import React from 'react';

const Footer = () => (
  <div className="fixed-bottom bg-dark text-white" id="footer">
    <p className="font-weight-bold text-center m-1 p-2">
      Made with ❤ by{' '}
      <a href="https://github.com/ShubhamSingal07" target="_blank">
        {' '}
        Shubham Singal
      </a>
    </p>
  </div>
);

export default Footer;
